import Link from "next/link";
import { Tabs } from "ui";
import { useCarriedQueryParams } from "./utils";

export function RiskNavigationTabs({
  activeTab,
}: {
  activeTab: "riskLists" | "riskRules";
}) {
  const query = useCarriedQueryParams();
  return (
    <Tabs value={activeTab}>
      <Tabs.List>
        <Tabs.Tab
          value="riskLists"
          nativeButton={false}
          render={<Link href={{ pathname: "/risk/lists", query }} />}
        >
          Risk Lists
        </Tabs.Tab>
        <Tabs.Tab
          value="riskRules"
          nativeButton={false}
          render={<Link href={{ pathname: "/risk/rules", query }} />}
        >
          Risk Rule
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
